export const shipOptions = ['1', '2', '3', '4', '5'];
